export default {
  get(context) {
    return new Promise((resolve, reject) => {
      return setTimeout(() => {
        resolve();
      }, 100);
    });
  }
};
